import { Injectable } from '@angular/core';
import { BaseCanActivateService } from '../core/base-can-activate.service';
import { CanActivate } from '@angular/router';
import { BookingStepsService } from '../core/booking-steps.service';
import { FlowManagerService } from '../core/flow-manager.service';

@Injectable()
export class CanActivateItineraryService extends BaseCanActivateService implements CanActivate {
  constructor(flowManager: FlowManagerService, steps: BookingStepsService) {
    super(steps, flowManager.applicationFlowService);
    this.forceFlowInfoRefresh = true;
  }
}
